module.exports = __webpack_public_path__ + "img/yxHome_bg.5913624d.png";